"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiSelectProps = void 0;
var ExpandDown_1 = __importDefault(require("@tdcerhverv/parrotfish/icons/ExpandDown"));
exports.MuiSelectProps = {
    variant: 'outlined',
    IconComponent: ExpandDown_1.default,
};
